import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import MapDashboard from './MapDashboard';
// Initialize Dashboard component when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    const dashboardContainer = document.getElementById('map-dashboard-container');
    if (dashboardContainer) {
        const root = ReactDOM.createRoot(dashboardContainer);
        root.render(_jsx(MapDashboard, {}));
    }
});
